import { KycStatus } from '@/api/common.types';
import { useCheckStatus } from '@/api/queryHooks/useKycController';

export const useIsKYBVerified = ({ isEnabled = true }: { isEnabled?: boolean } = {}) => {
  const { data: KycStatusData } = useCheckStatus({ refetchOnMount: true, enabled: isEnabled });
  return KycStatusData?.status === KycStatus.CLEAR || KycStatusData?.status === KycStatus.BIOMETRIC_REQUIRED;
};
